import React from "react";
import Cotizacion from "../../components/CotizacionAccidentePersonal/CotizacionAPersonal3";

const ContainerCotizacionAPersonal3 =()=> 
 
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <Cotizacion/>
          </div>
        </div>
      </main>
 

export default ContainerCotizacionAPersonal3
